import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ModalSelectCollectionsToAssignIncidentComponent } from "./modal-select-collections-to-assign-incident/modal-select-collections-to-assign-incident";
import { SharedModule } from "../../shared/shared.module";
import { TagInputModule } from "ngx-chips";

@NgModule({
  imports: [
    NgbModule,
    RouterModule,
    FormsModule,
    BrowserAnimationsModule,
    SharedModule,
    TagInputModule,
  ],
  declarations: [ModalSelectCollectionsToAssignIncidentComponent],
  exports: [ModalSelectCollectionsToAssignIncidentComponent],
  bootstrap: [],
  entryComponents: [ModalSelectCollectionsToAssignIncidentComponent],
})
export class ModalsComponentModule {}
